import { render, staticRenderFns } from "./ModalRelatorioGestao.vue?vue&type=template&id=2a01b806"
import script from "./ModalRelatorioGestao.vue?vue&type=script&lang=ts"
export * from "./ModalRelatorioGestao.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports